export default __webpack_public_path__ + "static/media/forgot.fb7552db.png";